module.exports = __webpack_public_path__ + "media/make2.0c945d97.mp4";